import React from 'react';
import LoginForm from '../components/LoginForm';
import RegisterForm from '../components/RegisterForm';
import './AuthPage.css';

const LoginPage = () => {
  return (
    <div className="container-fluid auth p-5">
      <div className="row justify-content-md-center">
        <div className="col-lg-4 col-md-6 col-sm-8 col-12 mx-lg-4 mx-md-4 mx-0 mb-5">
          <LoginForm />          
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
